import { componentMap } from '../../utils';

export default function getComponent(candidate) {
  return componentMap.get(candidate) || null;
}
